import SessionAvailabilityView from './components/availability-view';

export default SessionAvailabilityView;
